var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer",attrs:{"id":"footer"}},[_vm._v(" © 2020 Color Admin Responsive Admin Template - Sean Ngu All Rights Reserved ")])
}
var staticRenderFns = []

export { render, staticRenderFns }